export default __webpack_public_path__ + "static/partnerColorIcon11-a566aac4e9065eb45b34ecec1d601feb.svg";